module.exports = __webpack_public_path__ + "static/img/value1.4e9dec2.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/product/value1.png
// module id = 5kF3
// module chunks = 1